import {
  AssessmentEvent,
  MilestoneReportQuery,
  EngagementReportQuery,
  EngagementReportResult,
  EngagementReportType,
  PaginatableAssessmentHistoryArgs,
  PaginatableAssessmentHistoryResult,
  PaginatableAssessmentHistoryQuery,
  RequestBulkCCCReportQuery,
  RequestBulkCCCReportInput,
  RequestBulkCCCReportQueryVariables
} from "../../API";
import { genericQuery, listQueryAutoPaginated } from "../api/apiUtils";
import { assessmentHistoryForCCC } from "../../graphql/customQueries";
import {
  engagementReport,
  milestoneReport,
  requestBulkCCCReport
} from "../../graphql/queries";

export const fetchPaginatedAssessmentHistory = async (
  args: PaginatableAssessmentHistoryArgs
) => {
  const variables = { input: args };
  const results = await listQueryAutoPaginated<
    PaginatableAssessmentHistoryQuery,
    AssessmentEvent,
    PaginatableAssessmentHistoryResult
  >(
    assessmentHistoryForCCC,
    "paginatableAssessmentHistory",
    "items",
    variables
  );
  return results;
};

export const fetchMilestoneReport = async (programMembershipIds: string[]) => {
  const predicate = { programMembershipIds: programMembershipIds };
  const results = await genericQuery<MilestoneReportQuery, string>(
    milestoneReport,
    "milestoneReport",
    predicate
  );
  return results;
};

export const fetchUserReport = async (
  programId: string,
  startDate: string,
  endDate: string,
  role?: string
) => {
  const predicate = {
    input: {
      programId,
      startDate,
      endDate,
      role,
      reportType: EngagementReportType.User
    }
  };
  const results = await genericQuery<
    EngagementReportQuery,
    EngagementReportResult
  >(engagementReport, "engagementReport", predicate);

  return results;
};

export const fetchProgramReport = async (
  institutionId: string,
  startDate: string,
  endDate: string
) => {
  const predicate = {
    input: {
      institutionId,
      startDate,
      endDate,
      reportType: EngagementReportType.Program
    }
  };
  const results = await genericQuery<
    EngagementReportQuery,
    EngagementReportResult
  >(engagementReport, "engagementReport", predicate);

  return results;
};

export const initiateBulkCCCReportGeneration = async (
  input: RequestBulkCCCReportInput
) => {
  const variables: RequestBulkCCCReportQueryVariables = { input };
  return await genericQuery<RequestBulkCCCReportQuery, string>(
    requestBulkCCCReport,
    "requestBulkCCCReport",
    variables
  );
};
